import { gql } from '@apollo/client';
import { createContext, useContext, useEffect } from 'react';
import { useOutdatedClientQuery } from '../generated/hooks';

gql`
  query OutdatedClient {
    outdatedClient
  }
`;

const OutdatedClientContext = createContext(false);

export const OutdatedClientContextProvider = ({ children }: { children: React.ReactNode }) => {
  const {
    data: outdatedClientData,
    startPolling,
    stopPolling,
  } = useOutdatedClientQuery({
    fetchPolicy: 'network-only',
  });
  const outdatedClient = !!outdatedClientData?.outdatedClient;

  useEffect(() => {
    if (outdatedClient) {
      stopPolling();
    } else {
      startPolling(60000);
    }
  }, [outdatedClient, stopPolling, startPolling]);

  return (
    <OutdatedClientContext.Provider value={outdatedClient}>
      {children}
    </OutdatedClientContext.Provider>
  );
};

export const useIsClientOutdated = () => useContext(OutdatedClientContext);
